export enum Color {
	Main = "#e33124",
	Font = "#333333",
	LightFont = "#666666",
}
export enum Font {
	Main = "avenir,sans-serif",
}
